import { createDefu } from 'defu';

const isStringArray = (value: unknown): value is string[] => Array.isArray(value) && value.every((item) => typeof item === 'string');

const defu = createDefu((obj, key, value) => {
	if (isStringArray(obj[key])) obj[key] = (obj[key] as string[]).join(' ') as any;
	const normalizedValue = isStringArray(value) ? value.join(' ') : value;

	if (typeof obj[key] === 'string' && typeof normalizedValue === 'string') {
		obj[key] = `${normalizedValue} ${obj[key]}` as any;
		return true;
	}
});

export function mergeUi<TUi extends Record<string, unknown> | undefined, TOverrides extends Record<string, unknown> | undefined>(ui?: TUi, overrides?: TOverrides) {
	return defu((ui ?? {}) as NonNullable<TUi>, overrides);
}
